import { ISplitOrder, ISplitOrderParam, ISplitOrderDetail, ISplitSubOrder, ISplitOrderInfo, ISplitSubOrderParam, ISplitSubOrderItem } from '../../../types/air-splitting/bill-management/splitOrders';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 账单管理 - 分账订单管理
 */
export async function querySplitOrders(param: ISplitOrderParam) {
  let data = [] as ISplitOrder[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as ISplitOrderParam;

  try {
    const { code, context, message } = await Http.get<{ data: ISplitOrder[]; total: number }>(`${hostUrl}/pay/order/page`, { ...param });

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ISplitOrder[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 账单管理 - 分账子订单列表
 */
export async function querySubSplitOrders(id: string) {
  let data = [] as ISplitSubOrder[];

  try {
    const { code, context, message } = await Http.get<ISplitSubOrder[]>(`${hostUrl}/pay/order/sub-order-list`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 账单管理 - 分账订单详情
 */
export async function querySplitOrderDetail(id: string) {
  let data = {} as ISplitOrderInfo;

  try {
    const { code, context, message } = await Http.get<ISplitOrderInfo>(`${hostUrl}/pay/order/detail/${id}`, {});

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as ISplitOrderInfo;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 账单管理 - 分账订单详情
 */
export async function querySORDetail(id: string) {
  let data = {} as ISplitOrderDetail;

  try {
    const { code, context, message } = await Http.get<ISplitOrderDetail>(`${hostUrl}/pay/order/detail/${id}`);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as ISplitOrderDetail;

      data = items || {} as ISplitOrderDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 账单管理 - 取消订单
 */
export async function cancelSplitBillOrder(id: string) {

  try {
    const { code, message } = await Http.post<{ data; total: number }>(`${hostUrl}/pay/order/cancel/${id}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 账单管理 - 根据订单明细id获取回单地址
 */
export async function querySplitOrderReceiptList(params: {orderDetailId: number}) {
  let data = [] as string[];

  try {
    const { code, context, message } = await Http.get<string[]>(`${hostUrl}/pay/payer/receipt/get-receipt-urls`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 导出分账订单
 */
export async function exportSplitOrders(params: ISplitOrderParam) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/order/export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 账单管理 - 分账订单管理 - 分账明细列表
 */
export async function querySplitSubOrders(param: ISplitSubOrderParam) {
  let data = [] as ISplitSubOrderItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as ISplitSubOrderParam;

  try {
    const { code, context, message } = await Http.post<{ data: ISplitSubOrderItem[]; total: number }>(`${hostUrl}/pay/order/sub-order/page-query`, { ...param });

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ISplitSubOrderItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 导出分账订单
 */
export async function exportSplitSubOrders(params: ISplitSubOrderParam) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名
  
  try {
    const { code, context, message, headers } = await Http.post<Blob>(
      `${hostUrl}/pay/order/sub-order/export`, params, { responseType: 'blob' },
    );
  
    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);
  
      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }
  
    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  
  return {
    buffer,
    fileName, 
  };
}
